const PrimaryText = {
  90: '#85868B',
  80: '#929498',
  30: '#D6D7D8',
  10: '#081F3D',
};

export default PrimaryText;